import { IExecutionOptions, IQueryOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { IQueryOptionsHistoricalDatasets } from '../models/query/options';
import { BaseCollectionQuery } from './BaseCollectionQuery';
import { IHistoricalDataset } from '../models/api/search';
import { Query } from './Query';

export class HistoricalDatasetsQuery extends BaseCollectionQuery<IQueryOptionsHistoricalDatasets> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsHistoricalDatasets {
		const { entityType, code, codeQuery, key, keyQuery, extendedKey, collectionItemConditional, fields, sort, index, startIndex, endIndex, entityKey, entityIndex, options = {} } = this.queryOptions;
		return {
			entityType,
			code,
			codeQuery,
			key,
			keyQuery,
			collectionItemConditional,
			fields,
			sort,
			index,
			startIndex,
			endIndex,
			entityKey,
			entityIndex,
			...(options.historicalDatasets || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { sort, index, startIndex, endIndex } = this.options;
		return this.processEntities(executionOptions, (entity) => {
			if (entity) {
				let historicalDatasets = this.getHistoricalDatasets(executionOptions) as any;
				if (sort) {
					historicalDatasets = this.applySort(historicalDatasets, sort, undefined, executionOptions.inputs);
				}
				let result = historicalDatasets && historicalDatasets.map(historicalDataset => this.getHistoricalDatasetResult(executionOptions, historicalDataset));
				result = result.slice(startIndex, endIndex);
				if (result && result.length > 0) {
					if (typeof index === 'number') {
						const targetIndex = this.getIndex(index, result);
						if (targetIndex > -1) {
							const item = result[targetIndex];
							return item;
						}
					}
					else {
						return result;
					}
				}
				
				// if (index > -1 && result.length > index) {
				// 	return result[index];
				// }
				return result;
			}
		});
	}
	getHistoricalDatasets(executionOptions: IExecutionOptions): IHistoricalDataset[] {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const {
			code,
			asAtDate,
			asAtDateStart,
			asAtDateEnd,
			collectionItemConditional = { conditions: [] },
		} = this.options;
		if (code && !collectionItemConditional.conditions.find(condition => condition.field === 'code')) {
			collectionItemConditional.conditions.push({
				field: 'code',
				operator: '=',
				value: code,
			});
		}
		if (asAtDate && !collectionItemConditional.conditions.find(condition => condition.field === 'asAtDate')) {
			collectionItemConditional.conditions.push({
				field: 'asAtDate',
				operator: '=',
				value: asAtDate,
			});
		}
		if (asAtDateStart && asAtDateEnd && !collectionItemConditional.conditions.find(condition => condition.field === 'asAtDate')) {
			collectionItemConditional.conditions.push({
				field: 'asAtDate',
				operator: '>=',
				value: asAtDateStart,
			});
			collectionItemConditional.conditions.push({
				field: 'asAtDate',
				operator: '<=',
				value: asAtDateEnd,
			});
		}
		const collectionItems = this.getSubCollection(executionOptions)
			.filter(item => conditionalHelper.matches(item, collectionItemConditional, executionOptions));
		return collectionItems;
	}
	getHistoricalDatasetResult<T>(executionOptions: IExecutionOptions, historicalDataset: IHistoricalDataset): T {
		const { fields, childKey, childIndex } = this.options;
		if (!fields || fields.length === 0) {
			const { key } = this.options;
			return this.getHistoricalDatasetValue(executionOptions, historicalDataset, key, childKey, childIndex) as any;
		}

		const historicalDatasetResult: any = {};
		for (const field of fields) {
			const { name, key, childKey, childIndex, query } = field;
			historicalDatasetResult[name] = this.getHistoricalDatasetValue(executionOptions, historicalDataset, key, childKey, childIndex, query);
		}
		return historicalDatasetResult;
	}
	getHistoricalDatasetValue(executionOptions: IExecutionOptions, historicalDataset: IHistoricalDataset, key: string = null, childKey: string = null, childIndex: number = -1, query?: IQueryOptions) {
		if (historicalDataset) {
			if (!key && query) {
				const fieldQuery = new Query(query);
				return fieldQuery.execute({ ...executionOptions, responseContext: historicalDataset });
			}
			else if (key === 'values') {
				let values = historicalDataset.values;

				if (query) {
					const fieldQuery = new Query(query);
					values = fieldQuery.execute({ ...executionOptions, responseContext: values });
				}

				if (childIndex > -1 && values.length > childIndex) {
					if (childKey) {
						return values[childIndex][childKey];
					}
					return values[childIndex];
				}

				if (childKey) {
					return values.map(v => v[childKey]);
				}

				return values;
			}
			if (key) {
				return historicalDataset[key];
			}
			return historicalDataset;
		}
		return;
	}
}